import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalSection,
  ModalFooter,
  Paragraph,
} from '@axiom/ui';

export type ProfileImageEditDeleteConfirmModalProps = {
  name?: string;
  onDecline: () => void;
  onDelete: () => void;
};

export const ProfileImageEditDeleteConfirmModal = ({
  name = 'PROFILE_IMAGE_EDIT_DELETE_CONFIRM_MODAL',
  onDecline,
  onDelete,
}: ProfileImageEditDeleteConfirmModalProps) => (
  <Modal name={name} size="confirm">
    <ModalHeader onClose={onDecline}>Delete Photo</ModalHeader>
    <ModalSection>
      <Paragraph>Are you sure you want to delete this photo?</Paragraph>
    </ModalSection>
    <ModalFooter>
      <Button variation="outline" name="CANCEL" onClick={onDecline}>
        Cancel
      </Button>

      <Button name="DELETE" onClick={onDelete}>
        Delete
      </Button>
    </ModalFooter>
  </Modal>
);
